import { motion } from "framer-motion";

interface FunnelStep {
  label: string;
  value: number;
}

interface FunnelChartProps {
  steps: FunnelStep[];
}

export default function FunnelChart({ steps }: FunnelChartProps) {
  const maxValue = Math.max(steps[0]?.value ?? 1, 1);

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.22 }}
      className="bg-card rounded-2xl p-6 border border-border mb-8"
    >
      <h3 className="font-heading font-semibold text-foreground mb-4">Funil de Conversão</h3>
      <div className="space-y-3">
        {steps.map((step, i) => {
          const pct = Math.round((step.value / maxValue) * 100);
          return (
            <div key={i} className="flex items-center gap-4">
              <span className="text-sm font-medium text-foreground w-40">{step.label}</span>
              <div className="flex-1 bg-secondary rounded-full h-6 overflow-hidden">
                <div
                  className="h-full bg-primary/80 rounded-full flex items-center justify-end pr-2 transition-all"
                  style={{ width: `${Math.max(pct, 5)}%` }}
                >
                  <span className="text-xs font-bold text-primary-foreground">{step.value}</span>
                </div>
              </div>
              <span className="text-xs text-muted-foreground w-10 text-right">{pct}%</span>
            </div>
          );
        })}
      </div>
    </motion.div>
  );
}
